import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

interface ConstructionOption {
  name: string;
  label: string;
  checked: boolean;
  item: string | null;
}

@Component({
  selector: 'ciwc-construction-text',
  standalone: true,
  imports: [CommonModule, MatCheckboxModule],
  templateUrl: './construction-text.component.html',
  styleUrl: './construction-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConstructionTextComponent {
  @Input() isConstructionSheet = false;
  @Input() description: string | string[] = '';
  @Input() set constructionSheet(value: ConstructionOption[][]) {
    this._constructionSheetData.set(value);
  }

  private _constructionSheetData = signal<ConstructionOption[][]>([]);
  readonly constructionSheetData = this._constructionSheetData.asReadonly();
  readonly Math = Math;
}
